// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Uv79UlbIMjMXG_ytRty{display:flex;width:100%;height:100%}`, "",{"version":3,"sources":["webpack://./src/components/workflows/wasm-visual-editor/wasm-visual-editor-view.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".editorCanvas {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorCanvas": `_Uv79UlbIMjMXG_ytRty`
};
export default ___CSS_LOADER_EXPORT___;
